"use strict";

exports.__esModule = true;
exports.useRowSelection = useRowSelection;
var _react = require("react");
function useRowSelection() {
  var _useState = (0, _react.useState)(undefined),
    selectedRowIndex = _useState[0],
    setSelectedRowIndex = _useState[1];
  function resetSelectedRowIndex() {
    setSelectedRowIndex(undefined);
  }
  return {
    selectedRowIndex: selectedRowIndex,
    setSelectedRowIndex: setSelectedRowIndex,
    resetSelectedRowIndex: resetSelectedRowIndex
  };
}